<template>
  <v-container fluid class="mt-4">
    <v-row align="center" justify="center" class="mt-4">
      <v-col lg="8">
        <v-row>
          <v-col cols="12" md="6" v-for="(item, n) in items" :key="n">
            <v-card class="perso_card" @click="navigate(item.link)">
              <v-container fluid>
                <v-row>
                  <v-col cols="12" class="pt-0 ma-4">
                    <h2 class="text-h4 my-4">
                      {{ $t(item.title) }}
                    </h2>
                    <v-icon
                      x-large
                      color="secondary"
                      style="
                        position: absolute;
                        padding: 8px;
                        right: 8px;
                        top: 8px;
                      "
                    >
                      {{ item.icon }}
                    </v-icon>
                    <p class="text-body-1 mr-4" style="height: 48px">
                      {{ $t(item.content) }}
                    </p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
.perso_card {
  border: 1px solid rgba(202, 5, 56, 0.4);
}
</style>
<script>
export default {
  data() {
    return {
      items: [
        {
          title: "search.substance",
          content: "search.substanceDetails",
          icon: "mdi-flask-outline",
          link: "/SearchSubstances",
        },
        {
          title: "search.rule",
          content: "search.ruleDetails",
          icon: "mdi-clipboard",
          link: "/SearchRules",
        },
        {
          title: "search.use",
          content: "search.useDetails",
          icon: "mdi-cogs",
          link: "/SearchUses",
        },
        {
          title: "search.multiRules",
          content: "search.multiRulesDetails",
          icon: "mdi-clipboard-multiple",
          link: "/SearchMultiRules",
        },
      ],
    };
  },
  methods: {
    navigate(link) {
      this.$router.push(link);
    },
  },
};
</script>
